import "~styles/global"

import { initSentry } from "~root/sentry"
import { WrapRootElementBrowser } from "~utils/wrap-root-element"
import { WrapPageElementBrowser } from "~utils/wrap-page-element"

// Initialize Sentry dynamically
async function onClientEntry() {
    await initSentry()
}

function onRouteUpdate() {
    if (typeof window !== "undefined") {
        // Give the page a chance to load before scrolling to the top
        setTimeout(() => {
            // When gatsby does internal navigation. sometimes the page
            // doesn't scroll to the top. This forces it.
            window.scrollTo(0, 0)
        }, 50)
    }
}

// Returning null in replaceHydrateFunction allows us to see what
// the server renders without hydration
// function replaceHydrateFunction() {
//     return () => {
//         return null
//     }
// }

export {
    // eslint-disable-next-line import/no-unused-modules -- imported by gatsby
    WrapRootElementBrowser as wrapRootElement,
    // eslint-disable-next-line import/no-unused-modules -- imported by gatsby
    WrapPageElementBrowser as wrapPageElement,
    // eslint-disable-next-line import/no-unused-modules -- imported  by gatsby
    onClientEntry,
    // eslint-disable-next-line import/no-unused-modules -- imported  by gatsby
    onRouteUpdate,
}
